/**
 * Auth0 configuration
 * Load from environment variables
 */

interface Auth0Config {
  domain: string;
  clientId: string;
  authorizationParams: {
    redirect_uri: string;
    audience?: string;
    scope: string;
  };
  cacheLocation: 'localstorage' | 'memory';
  useRefreshTokens: boolean;
}

export const createAuth0Config = (config: {
  domain: string;
  clientId: string;
  audience?: string;
  redirectUri?: string;
}): Auth0Config => {
  const { domain, clientId, audience, redirectUri } = config;

  if (!domain || !clientId) {
    throw new Error('Auth0 configuration error: domain and clientId are required.');
  }

  return {
    domain,
    clientId,
    authorizationParams: {
      redirect_uri: redirectUri || window.location.origin,
      ...(audience && { audience }),
      scope: 'openid profile email',
    },
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
  };
};
